import { isEmail, isRequired } from 'evcharging/app/validation/validators';
import { SERVICES_CONTACT_FORM_ENDPOINT } from 'evcharging/app/server/endpoints';
import { httpClient } from 'evcharging/app/client';

const validators = {
  name: [isRequired],
  email: [isRequired, isEmail],
};

const sendServiceContactForm = (payload: Record<string, string | number>) =>
  httpClient()
    .setBody(payload)
    .setValidators(validators)
    .post(SERVICES_CONTACT_FORM_ENDPOINT);

export default sendServiceContactForm;
